// removed by extract-text-webpack-plugin
module.exports = {"header":"ai_mX","modal":"_1z6oM","close":"QUxrM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/Modal.css
// module id = 826
// module chunks = 0